<template>
  <v-tab-item :value="$route.fullPath" class="pa-3">
    <v-toolbar flat height="130">
      <ExportLinks export-key="store-point-analysis" :filters="filtersData" />

      <v-spacer></v-spacer>

      <v-col cols="12" sm="4">
        <v-menu :close-on-content-click="true" offset-y max-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field
              :label="translations.date[lang]"
              class="mb-4"
              color="secondary"
              autocomplete="off"
              hint="YYYY/DD format"
              rounded
              outlined
              dense
              clearable
              hide-details
              :prepend-inner-icon="icons.mdiCalendarSearch"
              v-on="on"
              v-model="filtersData.date"
            ></v-text-field>
          </template>

          <v-date-picker
            v-model="filtersData.date"
            color="secondary"
            type="month"
            no-title
          ></v-date-picker>
        </v-menu>
        <b-search-field v-model="search"></b-search-field>
      </v-col>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="pointAnalysis"
      :footer-props="{
        itemsPerPageOptions: [12],
        showCurrentPage: true,
        pageText: `${page * 12 - 11}-${
          page * 12 <= serverItemsLength ? page * 12 : serverItemsLength
        } ${translations.paginationText[lang]} ${serverItemsLength}`,
      }"
      :page.sync="page"
      :server-items-length="serverItemsLength"
      :loading="loading"
      class="b-outlined"
      :options.sync="options"
    >
      <!-- <template v-slot:item.shared="{ item }">
                <v-icon
                    v-if="item.shared"
                    color="green"
                    v-text="icons.mdiCheckCircleOutline"
                ></v-icon>
                <v-icon
                    v-else
                    color="red"
                    v-text="icons.mdiMinusCircleOutline"
                ></v-icon>
            </template> -->
    </v-data-table>
  </v-tab-item>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import ExportLinks from '@/components/general/ExportLinks.vue';
import translations from '@/utils/translations/storePanel/history';
import debounce from 'lodash/debounce';
import moment from 'moment';
import { mdiCheckCircleOutline, mdiMinusCircleOutline, mdiPencilOutline } from '@mdi/js';

export default {
  name: 'PointAnalysis',

  components: { ExportLinks },

  mixins: [translations],

  data() {
    return {
      page: +this.$route.query.page,
      icons: {
        mdiCheckCircleOutline,
        mdiMinusCircleOutline,
        mdiPencilOutline,
      },
      search: '',
      filtersData: {
        order: null,
        date: '',
      },
      options: {},
    };
  },

  computed: {
    ...mapState(['loading', 'serverItemsLength', 'superUser']),
    ...mapState('storePanel/history', ['pointAnalysis']),

    lang() {
      return this.$route.params.lang;
    },

    permission() {
      return this.$store.state.permissions.history
        ? this.$store.state.permissions.history.points_analysis
        : this.superUser;
    },

    headers() {
      return [
        {
          text: this.translations.date[this.lang],
          value: 'date_period',
        },
        {
          text: this.translations.product[this.lang],
          value: `product_name[${this.lang}]`,
        },
        {
          text: this.translations.paymentMethod[this.lang],
          value: `bank_provider_name[${this.lang}]`,
        },
        {
          text: this.translations.subsidized[this.lang],
          value: 'shared',
        },
        {
          text: this.translations.notSubsidized[this.lang],
          value: 'not_shared',
        },
      ];
    },

    query() {
      let query = '?';

      for (let key in this.$route.query) {
        query += `${key}=${this.$route.query[key]}&`;
      }

      return query.slice(0, query.length - 1);
    },
  },

  methods: {
    ...mapActions('storePanel/history', ['getPointAnalysis']),

    handleSearch() {
      let sendingData = {
        query: `?q=${this.search}`,
        filters: this.filtersData,
      };
      this.getPointAnalysis(sendingData);
    },

    getFilteredData() {
      let sendingData = {
        query: this.query,
        filters: this.filtersData,
      };
      this.getPointAnalysis(sendingData);
    },
  },

  watch: {
    options: {
      handler(val) {
        if (val.sortBy[0]) {
          this.filtersData.order = val.sortBy[0].split('[')[0];

          if (val.sortDesc) {
            this.filtersData.order += ',' + (val.sortDesc[0] ? 'desc' : 'asc');
          }
          this.getFilteredData();
        }
      },
      deep: true,
    },
    ['filtersData.date']: {
      immediate: true,
      handler(val) {
        if (val) {
          this.filtersData.date = moment(val).format('YYYY-MM');
          this.getFilteredData();
        }
      },
    },
    permission: {
      immediate: true,
      handler(val) {
        if (!val && !this.superUser) {
          this.$router.replace(`/${this.lang}/storePanel/forbidden-gateway`);
        }
      },
    },

    search(val) {
      if (val == null) {
        this.getFilteredData();
      } else {
        this.debouncedSearch();
      }
    },

    $route(val) {
      if (!val.query.page) {
        this.$router.replace({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }

      this.getFilteredData();
    },

    page(page) {
      this.$router.replace({ query: { ...this.$route.query, page } });
    },
  },

  beforeCreate() {
    if (!this.$route.query.page) {
      this.$router.replace({
        query: {
          page: 1,
          ...this.$route.query,
        },
      });
    }
  },

  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
  },

  mounted() {
    this.getFilteredData();
  },
};
</script>
